import React, { useEffect, useState } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import SupplierList from "./SupplierList";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAllSupplierDetails,
  clearEditedDetails,
} from "./_supplier_Action";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const Supplier = () => {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const dispatch = useDispatch();
  let allFetchData = useSelector((state) => state.supplier._allDetails) || [];

  useEffect(() => {
    if (allFetchData <= 0) dispatch(fetchAllSupplierDetails());

    dispatch(clearEditedDetails());
    // eslint-disable-next-line
  }, []);

  let viewComponent;
  viewComponent = <SupplierList TableData={allFetchData} filterFn={filterFn} />;

  return (
    <Page className={classes.root} title="Supplier">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn} />
        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};

export default Supplier;
